import { getUrl, Request } from "../../request";

import product1 from "../../../assets/images/base/products/20w50.png";
import product2 from "../../../assets/images/base/products/10w40.png";
import product3 from "../../../assets/images/base/products/5w30.png";
import product4 from "../../../assets/images/base/products/5w40.png";
import product5 from "../../../assets/images/base/products/0w20.png";
import product6 from "../../../assets/images/base/products/barrel/20w50.png";
import product7 from "../../../assets/images/base/products/barrel/10w40.png";
import product8 from "../../../assets/images/base/products/barrel/5w30.png";
import product9 from "../../../assets/images/base/products/barrel/5w40.png";
import product10 from "../../../assets/images/base/products/barrel/0w20.png";
import product11 from "../../../assets/images/base/products/tyre/falken.png";
import product12 from "../../../assets/images/base/products/tyre/kumho.png";
import product13 from "../../../assets/images/base/products/tyre/nano energy.png";
import product14 from "../../../assets/images/base/products/battery/acdelco.png";


export const getProductSliders = (city_id, category_id, home_page = false) => {
  const query = {
    city_id,
    category_id,
  };
  if (home_page) {
    query["home_page"] = 1;
  }

  if (home_page) {
    return new Promise((resolve, reject) => {
      resolve({
        success: true,
        data: [
          {
            "id": 104,
            "name": "Top Seller",
            "products": [{
              "id": 66,
              "product_id": 66,
              "product_link": "",
              "use_details": true,
              "tag": "product-66",
              "name": "Motosel 20W50 SP 5QT 4-pack",
              "label": "",
              "label_style": "none",
              "unit": "عدد",
              "price": 29.4,
              "payable_amount": 29.4,
              "discount_amount": 0,
              "usable_credit_amount": 0,
              "image": product6,
              "is_active": true,
              "cash_payment": false,
              "details": [],
              "fixed_discount_amount": 0,
              "discount_percentage": 0,
              "visible_discount_type": "fixed",
              "purchasable_count": 4,
              "orders_count": 0,
              "has_free_discount": true,
              "has_free_wage": false,
              "count_step": 1,
              "service_center_service_required": true,
              "service_center_delivery_required": true,
              "type": null,
              "quantity": 0,
              "address_id": null,
              "delivery_date": null,
              "delivery_shift": null,
              "service_center_id": null,
              "city": 12,
              "site": 1,
              "seller": 1
            },
            {
              "id": 67,
              "product_id": 67,
              "product_link": "",
              "use_details": true,
              "tag": "product-66",
              "name": "Motosel 1OW40 SP 5QT 4-pack",
              "label": "",
              "label_style": "none",
              "unit": "عدد",
              "price": 43.5,
              "payable_amount": 43.5,
              "discount_amount": 0,
              "usable_credit_amount": 0,
              "image": product7,
              "is_active": true,
              "cash_payment": false,
              "details": [],
              "fixed_discount_amount": 0,
              "discount_percentage": 0,
              "visible_discount_type": "fixed",
              "purchasable_count": 4,
              "orders_count": 0,
              "has_free_discount": true,
              "has_free_wage": false,
              "count_step": 1,
              "service_center_service_required": true,
              "service_center_delivery_required": true,
              "type": null,
              "quantity": 0,
              "address_id": null,
              "delivery_date": null,
              "delivery_shift": null,
              "service_center_id": null,
              "city": 12,
              "site": 1,
              "seller": 1
            },
            {
              "id": 68,
              "product_id": 68,
              "product_link": "",
              "use_details": true,
              "tag": "product-66",
              "name": "Motosel 5W40 SP 5QT 4-pack",
              "label": "",
              "label_style": "none",
              "unit": "عدد",
              "price": 58,
              "payable_amount": 58,
              "discount_amount": 0,
              "usable_credit_amount": 0,
              "image": product8,
              "is_active": true,
              "cash_payment": false,
              "details": [],
              "fixed_discount_amount": 0,
              "discount_percentage": 0,
              "visible_discount_type": "fixed",
              "purchasable_count": 4,
              "orders_count": 0,
              "has_free_discount": true,
              "has_free_wage": false,
              "count_step": 1,
              "service_center_service_required": true,
              "service_center_delivery_required": true,
              "type": null,
              "quantity": 0,
              "address_id": null,
              "delivery_date": null,
              "delivery_shift": null,
              "service_center_id": null,
              "city": 12,
              "site": 1,
              "seller": 1
            },
            {
              "id": 69,
              "product_id": 69,
              "product_link": "",
              "use_details": true,
              "tag": "product-66",
              "name": "Motosel 5W30 SP 5QT 4-pack",
              "label": "",
              "label_style": "none",
              "unit": "عدد",
              "price": 55.1,
              "payable_amount": 55.1,
              "discount_amount": 0,
              "usable_credit_amount": 0,
              "image": product9,
              "is_active": true,
              "cash_payment": false,
              "details": [],
              "fixed_discount_amount": 0,
              "discount_percentage": 0,
              "visible_discount_type": "fixed",
              "purchasable_count": 4,
              "orders_count": 0,
              "has_free_discount": true,
              "has_free_wage": false,
              "count_step": 1,
              "service_center_service_required": true,
              "service_center_delivery_required": true,
              "type": null,
              "quantity": 0,
              "address_id": null,
              "delivery_date": null,
              "delivery_shift": null,
              "service_center_id": null,
              "city": 12,
              "site": 1,
              "seller": 1
            },
            {
              "id": 70,
              "product_id": 70,
              "product_link": "",
              "use_details": true,
              "tag": "product-66",
              "name": "Motosel OW20 SP 5QT 4-pack",
              "label": "",
              "label_style": "none",
              "unit": "عدد",
              "price": 58,
              "payable_amount": 58,
              "discount_amount": 0,
              "usable_credit_amount": 0,
              "image": product10,
              "is_active": true,
              "cash_payment": false,
              "details": [],
              "fixed_discount_amount": 0,
              "discount_percentage": 0,
              "visible_discount_type": "fixed",
              "purchasable_count": 4,
              "orders_count": 0,
              "has_free_discount": true,
              "has_free_wage": false,
              "count_step": 1,
              "service_center_service_required": true,
              "service_center_delivery_required": true,
              "type": null,
              "quantity": 0,
              "address_id": null,
              "delivery_date": null,
              "delivery_shift": null,
              "service_center_id": null,
              "city": 12,
              "site": 1,
              "seller": 1
            },]
          },
          {
            "id": 63,
            "name": "Highly Demanded",
            "products": [{
              "id": 61,
              "product_id": 61,
              "product_link": "",
              "use_details": true,
              "tag": "product-61",
              "name": "Motosel 20W50 SP - 208L",
              "label": "",
              "label_style": "none",
              "unit": "عدد",
              "price": 326,
              "payable_amount": 326,
              "discount_amount": 0,
              "usable_credit_amount": 0,
              "image": product1,
              "is_active": true,
              "cash_payment": false,
              "details": [],
              "fixed_discount_amount": 0,
              "discount_percentage": 0,
              "visible_discount_type": "fixed",
              "purchasable_count": 4,
              "orders_count": 0,
              "has_free_discount": true,
              "has_free_wage": false,
              "count_step": 1,
              "service_center_service_required": true,
              "service_center_delivery_required": true,
              "type": null,
              "quantity": 0,
              "address_id": null,
              "delivery_date": null,
              "delivery_shift": null,
              "service_center_id": null,
              "city": 12,
              "site": 1,
              "seller": 1
            },
            {
              "id": 62,
              "product_id": 62,
              "product_link": "",
              "use_details": true,
              "tag": "product-62",
              "name": "Motosel 10W40 SP - 208L",
              "label": "",
              "label_style": "none",
              "unit": "عدد",
              "price": 464,
              "payable_amount": 464,
              "discount_amount": 0,
              "usable_credit_amount": 0,
              "image": product2,
              "is_active": true,
              "cash_payment": false,
              "details": [],
              "fixed_discount_amount": 0,
              "discount_percentage": 0,
              "visible_discount_type": "fixed",
              "purchasable_count": 4,
              "orders_count": 0,
              "has_free_discount": false,
              "has_free_wage": false,
              "count_step": 1,
              "service_center_service_required": true,
              "service_center_delivery_required": true,
              "type": null,
              "quantity": 0,
              "address_id": null,
              "delivery_date": null,
              "delivery_shift": null,
              "service_center_id": null,
              "city": 12,
              "site": 1,
              "seller": 1
            },
            {
              "id": 63,
              "product_id": 63,
              "product_link": "",
              "use_details": true,
              "tag": "product-63",
              "name": "Motosel 5W30 SP GF-6A - 208L",
              "label": "",
              "label_style": "none",
              "unit": "عدد",
              "price": 588,
              "payable_amount": 588,
              "discount_amount": 0,
              "usable_credit_amount": 0,
              "image": product3,
              "is_active": true,
              "cash_payment": false,
              "details": [],
              "fixed_discount_amount": 0,
              "discount_percentage": 0,
              "visible_discount_type": "fixed",
              "purchasable_count": 4,
              "orders_count": 0,
              "has_free_discount": true,
              "has_free_wage": false,
              "count_step": 1,
              "service_center_service_required": true,
              "service_center_delivery_required": true,
              "type": null,
              "quantity": 0,
              "address_id": null,
              "delivery_date": null,
              "delivery_shift": null,
              "service_center_id": null,
              "city": 12,
              "site": 1,
              "seller": 1
            },
            {
              "id": 64,
              "product_id": 64,
              "product_link": "",
              "use_details": true,
              "tag": "product-64",
              "name": "Motosel 5W40 SP Euro Line - 208L",
              "label": "",
              "label_style": "none",
              "unit": "عدد",
              "price": 619,
              "payable_amount": 619,
              "discount_amount": 0,
              "usable_credit_amount": 0,
              "image": product4,
              "is_active": true,
              "cash_payment": false,
              "details": [],
              "fixed_discount_amount": 0,
              "discount_percentage": 0,
              "visible_discount_type": "fixed",
              "purchasable_count": 4,
              "orders_count": 0,
              "has_free_discount": true,
              "has_free_wage": false,
              "count_step": 1,
              "service_center_service_required": true,
              "service_center_delivery_required": true,
              "type": null,
              "quantity": 0,
              "address_id": null,
              "delivery_date": null,
              "delivery_shift": null,
              "service_center_id": null,
              "city": 12,
              "site": 1,
              "seller": 1
            },
            {
              "id": 65,
              "product_id": 65,
              "product_link": "",
              "use_details": true,
              "tag": "product-64",
              "name": "Motosel 0W20 SP GF-6 GEN 2 - 208L",
              "label": "",
              "label_style": "none",
              "unit": "عدد",
              "price": 629,
              "payable_amount": 629,
              "discount_amount": 0,
              "usable_credit_amount": 0,
              "image": product5,
              "is_active": true,
              "cash_payment": false,
              "details": [],
              "fixed_discount_amount": 0,
              "discount_percentage": 0,
              "visible_discount_type": "fixed",
              "purchasable_count": 4,
              "orders_count": 0,
              "has_free_discount": true,
              "has_free_wage": false,
              "count_step": 1,
              "service_center_service_required": true,
              "service_center_delivery_required": true,
              "type": null,
              "quantity": 0,
              "address_id": null,
              "delivery_date": null,
              "delivery_shift": null,
              "service_center_id": null,
              "city": 12,
              "site": 1,
              "seller": 1
            },]
          },
        ]
      });
    })
  }

  return Request.get(getUrl("/api/v1/sellers/product-sliders/"), query);
};

export const getSellerProducts = (city_id, category_id, filter_query) => {
  switch (category_id) {
    case "2":
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({
            success: true,
            data: [
              {
                "id": 61,
                "product_id": 61,
                "product_link": "",
                "use_details": true,
                "tag": "product-61",
                "name": "Motosel 20W50 SP - 208L",
                "label": "",
                "label_style": "none",
                "unit": "عدد",
                "price": 326,
                "payable_amount": 326,
                "discount_amount": 0,
                "usable_credit_amount": 0,
                "image": product1,
                "is_active": true,
                "cash_payment": false,
                "details": [],
                "fixed_discount_amount": 0,
                "discount_percentage": 0,
                "visible_discount_type": "fixed",
                "purchasable_count": 4,
                "orders_count": 0,
                "has_free_discount": true,
                "has_free_wage": false,
                "count_step": 1,
                "service_center_service_required": true,
                "service_center_delivery_required": true,
                "type": null,
                "quantity": 0,
                "address_id": null,
                "delivery_date": null,
                "delivery_shift": null,
                "service_center_id": null,
                "city": 12,
                "site": 1,
                "seller": 1
              },
              {
                "id": 62,
                "product_id": 62,
                "product_link": "",
                "use_details": true,
                "tag": "product-62",
                "name": "Motosel 10W40 SP - 208L",
                "label": "",
                "label_style": "none",
                "unit": "عدد",
                "price": 464,
                "payable_amount": 464,
                "discount_amount": 0,
                "usable_credit_amount": 0,
                "image": product2,
                "is_active": true,
                "cash_payment": false,
                "details": [],
                "fixed_discount_amount": 0,
                "discount_percentage": 0,
                "visible_discount_type": "fixed",
                "purchasable_count": 4,
                "orders_count": 0,
                "has_free_discount": false,
                "has_free_wage": false,
                "count_step": 1,
                "service_center_service_required": true,
                "service_center_delivery_required": true,
                "type": null,
                "quantity": 0,
                "address_id": null,
                "delivery_date": null,
                "delivery_shift": null,
                "service_center_id": null,
                "city": 12,
                "site": 1,
                "seller": 1
              },
              {
                "id": 63,
                "product_id": 63,
                "product_link": "",
                "use_details": true,
                "tag": "product-63",
                "name": "Motosel 5W30 SP GF-6A - 208L",
                "label": "",
                "label_style": "none",
                "unit": "عدد",
                "price": 588,
                "payable_amount": 588,
                "discount_amount": 0,
                "usable_credit_amount": 0,
                "image": product3,
                "is_active": true,
                "cash_payment": false,
                "details": [],
                "fixed_discount_amount": 0,
                "discount_percentage": 0,
                "visible_discount_type": "fixed",
                "purchasable_count": 4,
                "orders_count": 0,
                "has_free_discount": true,
                "has_free_wage": false,
                "count_step": 1,
                "service_center_service_required": true,
                "service_center_delivery_required": true,
                "type": null,
                "quantity": 0,
                "address_id": null,
                "delivery_date": null,
                "delivery_shift": null,
                "service_center_id": null,
                "city": 12,
                "site": 1,
                "seller": 1
              },
              {
                "id": 64,
                "product_id": 64,
                "product_link": "",
                "use_details": true,
                "tag": "product-64",
                "name": "Motosel 5W40 SP Euro Line - 208L",
                "label": "",
                "label_style": "none",
                "unit": "عدد",
                "price": 619,
                "payable_amount": 619,
                "discount_amount": 0,
                "usable_credit_amount": 0,
                "image": product4,
                "is_active": true,
                "cash_payment": false,
                "details": [],
                "fixed_discount_amount": 0,
                "discount_percentage": 0,
                "visible_discount_type": "fixed",
                "purchasable_count": 4,
                "orders_count": 0,
                "has_free_discount": true,
                "has_free_wage": false,
                "count_step": 1,
                "service_center_service_required": true,
                "service_center_delivery_required": true,
                "type": null,
                "quantity": 0,
                "address_id": null,
                "delivery_date": null,
                "delivery_shift": null,
                "service_center_id": null,
                "city": 12,
                "site": 1,
                "seller": 1
              },
              {
                "id": 65,
                "product_id": 65,
                "product_link": "",
                "use_details": true,
                "tag": "product-64",
                "name": "Motosel 0W20 SP GF-6 GEN 2 - 208L",
                "label": "",
                "label_style": "none",
                "unit": "عدد",
                "price": 629,
                "payable_amount": 629,
                "discount_amount": 0,
                "usable_credit_amount": 0,
                "image": product5,
                "is_active": true,
                "cash_payment": false,
                "details": [],
                "fixed_discount_amount": 0,
                "discount_percentage": 0,
                "visible_discount_type": "fixed",
                "purchasable_count": 4,
                "orders_count": 0,
                "has_free_discount": true,
                "has_free_wage": false,
                "count_step": 1,
                "service_center_service_required": true,
                "service_center_delivery_required": true,
                "type": null,
                "quantity": 0,
                "address_id": null,
                "delivery_date": null,
                "delivery_shift": null,
                "service_center_id": null,
                "city": 12,
                "site": 1,
                "seller": 1
              },
              {
                "id": 66,
                "product_id": 66,
                "product_link": "",
                "use_details": true,
                "tag": "product-66",
                "name": "Motosel 20W50 SP 5QT 4-pack",
                "label": "",
                "label_style": "none",
                "unit": "عدد",
                "price": 29.4,
                "payable_amount": 29.4,
                "discount_amount": 0,
                "usable_credit_amount": 0,
                "image": product6,
                "is_active": true,
                "cash_payment": false,
                "details": [],
                "fixed_discount_amount": 0,
                "discount_percentage": 0,
                "visible_discount_type": "fixed",
                "purchasable_count": 4,
                "orders_count": 0,
                "has_free_discount": true,
                "has_free_wage": false,
                "count_step": 1,
                "service_center_service_required": true,
                "service_center_delivery_required": true,
                "type": null,
                "quantity": 0,
                "address_id": null,
                "delivery_date": null,
                "delivery_shift": null,
                "service_center_id": null,
                "city": 12,
                "site": 1,
                "seller": 1
              },
              {
                "id": 67,
                "product_id": 67,
                "product_link": "",
                "use_details": true,
                "tag": "product-66",
                "name": "Motosel 1OW40 SP 5QT 4-pack",
                "label": "",
                "label_style": "none",
                "unit": "عدد",
                "price": 43.5,
                "payable_amount": 43.5,
                "discount_amount": 0,
                "usable_credit_amount": 0,
                "image": product7,
                "is_active": true,
                "cash_payment": false,
                "details": [],
                "fixed_discount_amount": 0,
                "discount_percentage": 0,
                "visible_discount_type": "fixed",
                "purchasable_count": 4,
                "orders_count": 0,
                "has_free_discount": true,
                "has_free_wage": false,
                "count_step": 1,
                "service_center_service_required": true,
                "service_center_delivery_required": true,
                "type": null,
                "quantity": 0,
                "address_id": null,
                "delivery_date": null,
                "delivery_shift": null,
                "service_center_id": null,
                "city": 12,
                "site": 1,
                "seller": 1
              },
              {
                "id": 68,
                "product_id": 68,
                "product_link": "",
                "use_details": true,
                "tag": "product-66",
                "name": "Motosel 5W40 SP 5QT 4-pack",
                "label": "",
                "label_style": "none",
                "unit": "عدد",
                "price": 58,
                "payable_amount": 58,
                "discount_amount": 0,
                "usable_credit_amount": 0,
                "image": product8,
                "is_active": true,
                "cash_payment": false,
                "details": [],
                "fixed_discount_amount": 0,
                "discount_percentage": 0,
                "visible_discount_type": "fixed",
                "purchasable_count": 4,
                "orders_count": 0,
                "has_free_discount": true,
                "has_free_wage": false,
                "count_step": 1,
                "service_center_service_required": true,
                "service_center_delivery_required": true,
                "type": null,
                "quantity": 0,
                "address_id": null,
                "delivery_date": null,
                "delivery_shift": null,
                "service_center_id": null,
                "city": 12,
                "site": 1,
                "seller": 1
              },
              {
                "id": 69,
                "product_id": 69,
                "product_link": "",
                "use_details": true,
                "tag": "product-66",
                "name": "Motosel 5W30 SP 5QT 4-pack",
                "label": "",
                "label_style": "none",
                "unit": "عدد",
                "price": 55.1,
                "payable_amount": 55.1,
                "discount_amount": 0,
                "usable_credit_amount": 0,
                "image": product9,
                "is_active": true,
                "cash_payment": false,
                "details": [],
                "fixed_discount_amount": 0,
                "discount_percentage": 0,
                "visible_discount_type": "fixed",
                "purchasable_count": 4,
                "orders_count": 0,
                "has_free_discount": true,
                "has_free_wage": false,
                "count_step": 1,
                "service_center_service_required": true,
                "service_center_delivery_required": true,
                "type": null,
                "quantity": 0,
                "address_id": null,
                "delivery_date": null,
                "delivery_shift": null,
                "service_center_id": null,
                "city": 12,
                "site": 1,
                "seller": 1
              },
              {
                "id": 70,
                "product_id": 70,
                "product_link": "",
                "use_details": true,
                "tag": "product-66",
                "name": "Motosel OW20 SP 5QT 4-pack",
                "label": "",
                "label_style": "none",
                "unit": "عدد",
                "price": 58,
                "payable_amount": 58,
                "discount_amount": 0,
                "usable_credit_amount": 0,
                "image": product10,
                "is_active": true,
                "cash_payment": false,
                "details": [],
                "fixed_discount_amount": 0,
                "discount_percentage": 0,
                "visible_discount_type": "fixed",
                "purchasable_count": 4,
                "orders_count": 0,
                "has_free_discount": true,
                "has_free_wage": false,
                "count_step": 1,
                "service_center_service_required": true,
                "service_center_delivery_required": true,
                "type": null,
                "quantity": 0,
                "address_id": null,
                "delivery_date": null,
                "delivery_shift": null,
                "service_center_id": null,
                "city": 12,
                "site": 1,
                "seller": 1
              },
            ],
            code: 200
          })
        }, 500);
      })
    case "4":
      return new Promise((resolve, reject) => { 
        resolve({
          success: true,
          data: [{
            "id": 71,
            "product_id": 71,
            "product_link": "",
            "use_details": true,
            "tag": "product-71",
            "name": "Azenis Fk510 FALKEN - 225/45R18",
            "label": "",
            "label_style": "none",
            "unit": "عدد",
            "price": 37.89,
            "payable_amount": 37.89,
            "discount_amount": 0,
            "usable_credit_amount": 0,
            "image": product11,
            "is_active": true,
            "cash_payment": false,
            "details": [],
            "fixed_discount_amount": 0,
            "discount_percentage": 0,
            "visible_discount_type": "fixed",
            "purchasable_count": 4,
            "orders_count": 0,
            "has_free_discount": true,
            "has_free_wage": false,
            "count_step": 1,
            "service_center_service_required": true,
            "service_center_delivery_required": true,
            "type": null,
            "quantity": 0,
            "address_id": null,
            "delivery_date": null,
            "delivery_shift": null,
            "service_center_id": null,
            "city": 12,
            "site": 1,
            "seller": 1
          },{
            "id": 72,
            "product_id": 72,
            "product_link": "",
            "use_details": true,
            "tag": "product-72",
            "name": "Crogen Hp71 Kumho - 245/60R18",
            "label": "",
            "label_style": "none",
            "unit": "عدد",
            "price": 48.015,
            "payable_amount": 48.015,
            "discount_amount": 0,
            "usable_credit_amount": 0,
            "image": product12,
            "is_active": true,
            "cash_payment": false,
            "details": [],
            "fixed_discount_amount": 0,
            "discount_percentage": 0,
            "visible_discount_type": "fixed",
            "purchasable_count": 4,
            "orders_count": 0,
            "has_free_discount": true,
            "has_free_wage": false,
            "count_step": 1,
            "service_center_service_required": true,
            "service_center_delivery_required": true,
            "type": null,
            "quantity": 0,
            "address_id": null,
            "delivery_date": null,
            "delivery_shift": null,
            "service_center_id": null,
            "city": 12,
            "site": 1,
            "seller": 1
          },{
            "id": 73,
            "product_id": 73,
            "product_link": "",
            "use_details": true,
            "tag": "product-72",
            "name": "Nano Energy 3 Toyo - 195/65R15",
            "label": "",
            "label_style": "none",
            "unit": "عدد",
            "price": 22.500,
            "payable_amount": 22.500,
            "discount_amount": 0,
            "usable_credit_amount": 0,
            "image": product13,
            "is_active": true,
            "cash_payment": false,
            "details": [],
            "fixed_discount_amount": 0,
            "discount_percentage": 0,
            "visible_discount_type": "fixed",
            "purchasable_count": 4,
            "orders_count": 0,
            "has_free_discount": true,
            "has_free_wage": false,
            "count_step": 1,
            "service_center_service_required": true,
            "service_center_delivery_required": true,
            "type": null,
            "quantity": 0,
            "address_id": null,
            "delivery_date": null,
            "delivery_shift": null,
            "service_center_id": null,
            "city": 12,
            "site": 1,
            "seller": 1
          }],
          code: 200
        });
       });
    case "7":
      return new Promise((resolve, reject) => { 
        resolve({
          success: true,
          data: [{
            "id": 73,
            "product_id": 73,
            "product_link": "",
            "use_details": true,
            "tag": "product-73",
            "name": "Acdelco battery 12v 71 Ah/ M71-T7",
            "label": "",
            "label_style": "none",
            "unit": "عدد",
            "price": 37.89,
            "payable_amount": 37.89,
            "discount_amount": 0,
            "usable_credit_amount": 0,
            "image": product14,
            "is_active": true,
            "cash_payment": false,
            "details": [],
            "fixed_discount_amount": 0,
            "discount_percentage": 0,
            "visible_discount_type": "fixed",
            "purchasable_count": 4,
            "orders_count": 0,
            "has_free_discount": true,
            "has_free_wage": false,
            "count_step": 1,
            "service_center_service_required": true,
            "service_center_delivery_required": true,
            "type": null,
            "quantity": 0,
            "address_id": null,
            "delivery_date": null,
            "delivery_shift": null,
            "service_center_id": null,
            "city": 12,
            "site": 1,
            "seller": 1
          }],
          code: 200
        });
       })
    default:
      return new Promise((resolve, reject) => {
        resolve({
          success: true,
          data: [],
          code: 200
        })
      });
  }
  // return Request.get(getUrl("/api/v1/sellers/products/"), {
  //   ...filter_query,
  //   city_id,
  //   category_id,
  // });
};

export const getProductsSearch = (city_id, search) => {
  return Request.get(getUrl("/api/v1/sellers/products-search/"), {
    city_id,
    search,
  });
};

export const postCard = (seller_product_id, city_id, quantity, cart_items) => {
  return Request.post(getUrl("/api/v1/sellers/card/"), {
    seller_product_id,
    city_id,
    quantity,
    cart_items,
  });
};

export const getProductsFilters = (category_id, city_id) => {
  return Request.get(getUrl("/api/v1/sellers/products-filters/"), {
    category_id,
    city_id,
  });
};

export const getProductDelivery = (seller_product_id, city_id, type) => {
  return Request.get(getUrl("/api/v1/sellers/product-delivery/"), {
    seller_product_id,
    city_id,
    type,
  });

  // return new Promise((resolve, reject) => {
  //   setTimeout(() => {
  //     resolve({
  //       success: true,
  //       data: [
  //         {
  //           "id": 26931,
  //           "name": "Auto Pro",
  //           "phone_number": "09124897464",
  //           "address": {
  //             "region": "2 mi-Site 7002",
  //             "address": "Al Baany Rd,behind Four Point ",
  //             "latitude": "35.606507",
  //             "longitude": "51.428551"
  //           },
  //           "features": [],
  //           "details": [{
  //             title: "Services",
  //             list: ["Fuel", "Oil change", "Tire Change"]
  //           }],
  //           "shifts": [{ value: 'first', fee: '50', name: '4PM - 6PM' }, { value: 'first', fee: '50', name: '6PM - 8PM' }, { value: null, fee: '100', name: '4PM - 6PM' }, { value: null, fee: '100', name: '6PM - 8PM' }, { value: null, fee: '100', name: '8PM - 9PM' }],
  //           "user": {
  //             "full_name": "مصطفی  محمدی ارشد"
  //           },
  //           "dates": [
  //             { month: 'mar', day: 'Mon', date: '07', shifts: [{ value: 'first', fee: '50', name: '4PM - 6PM' }, 
  //             { value: 'first', fee: '50', name: '6PM - 8PM', shifts: [{ value: 'first', fee: '50', name: '4PM - 6PM' }, { value: 'first', fee: '50', name: '6PM - 8PM' }, { value: null, fee: '100', name: '4PM - 6PM' }, { value: null, fee: '100', name: '6PM - 8PM' }, { value: null, fee: '100', name: '8PM - 9PM' }] }, 
  //             { value: null, fee: '100', name: '4PM - 6PM', shifts: [{ value: 'first', fee: '50', name: '4PM - 6PM' }, { value: 'first', fee: '50', name: '6PM - 8PM' }, { value: null, fee: '100', name: '4PM - 6PM' }, { value: null, fee: '100', name: '6PM - 8PM' }, { value: null, fee: '100', name: '8PM - 9PM' }] }, 
  //             { value: null, fee: '100', name: '6PM - 8PM', shifts: [{ value: 'first', fee: '50', name: '4PM - 6PM' }, { value: 'first', fee: '50', name: '6PM - 8PM' }, { value: null, fee: '100', name: '4PM - 6PM' }, { value: null, fee: '100', name: '6PM - 8PM' }, { value: null, fee: '100', name: '8PM - 9PM' }] }, 
  //             { value: null, fee: '100', name: '8PM - 9PM', shifts: [{ value: 'first', fee: '50', name: '4PM - 6PM' }, { value: 'first', fee: '50', name: '6PM - 8PM' }, { value: null, fee: '100', name: '4PM - 6PM' }, { value: null, fee: '100', name: '6PM - 8PM' }, { value: null, fee: '100', name: '8PM - 9PM' }] }] },
  //             { month: 'mar', day: 'Tue', date: '08', shifts: [{ value: 'first', fee: '50', name: '4PM - 6PM' }, { value: 'first', fee: '50', name: '6PM - 8PM' }, { value: null, fee: '100', name: '4PM - 6PM' }, { value: null, fee: '100', name: '6PM - 8PM' }, { value: null, fee: '100', name: '8PM - 9PM' }] }, 
  //             { month: 'mar', day: 'Wed', date: '09', shifts: [{ value: 'first', fee: '50', name: '4PM - 6PM' }, { value: 'first', fee: '50', name: '6PM - 8PM' }, { value: null, fee: '100', name: '4PM - 6PM' }, { value: null, fee: '100', name: '6PM - 8PM' }, { value: null, fee: '100', name: '8PM - 9PM' }] }, 
  //             { month: 'mar', day: 'Thu', date: '10', shifts: [{ value: 'first', fee: '50', name: '4PM - 6PM' }, { value: 'first', fee: '50', name: '6PM - 8PM' }, { value: null, fee: '100', name: '4PM - 6PM' }, { value: null, fee: '100', name: '6PM - 8PM' }, { value: null, fee: '100', name: '8PM - 9PM' }] }],
  //           "rate": {
  //             "value": 4.0,
  //             "count": 60
  //           }
  //         },
  //         // {
  //         //   "id": 3449,
  //         //   "name": "عامری 1",
  //         //   "phone_number": "09121238486",
  //         //   "address": {
  //         //     "region": "منطقه ۱۵",
  //         //     "address": "خیابان 17 شهریور جنوبی خیابان رستگاری مقدم پلاک 123",
  //         //     "latitude": "35.649863",
  //         //     "longitude": "51.439953"
  //         //   },
  //         //   "features": [],
  //         //   "user": {
  //         //     "full_name": "مصطفی عامری"
  //         //   },
  //         //   "dates": [],
  //         //   "rate": {
  //         //     "value": 4.1,
  //         //     "count": 965
  //         //   }
  //         // },
  //         // {
  //         //   "id": 26098,
  //         //   "name": "اتوسرویس میلاد",
  //         //   "phone_number": "09367618046",
  //         //   "features": [],
  //         //   "details": [{
  //         //     title: "Services",
  //         //     list: ["Fuel", "Oil change", "Tire Change"]
  //         //   }],
  //         //   "address": {
  //         //     "region": "منطقه ۱۸",
  //         //     "address": "اسلامشهر باغ نرده خ سلمان فارسی نبش کوچه ۱۹ پ۴۴۵",
  //         //     "latitude": "35.550853",
  //         //     "longitude": "51.220509"
  //         //   },
  //         //   "user": {
  //         //     "full_name": "رضا قاسمیه"
  //         //   },
  //         //   "dates": [],
  //         //   "rate": {
  //         //     "value": 4.5,
  //         //     "count": 522
  //         //   }
  //         // }
  //       ],
  //       code: 200
  //     })
  //   }, 1000);
  // })
};
